// shared-lib/cabinet-runs/objectWallIds.js
//
// THE reader for which wall ids an object stands on. A run's objects name
// their wall in one of TWO fields, by producer: the run engine persists
// `parentWallIds`; the generator's apply persists `cabinetWallRefs` and
// strips `parentWallIds` (`fromPhaseB`). One room holds both shapes at once —
// a leg re-solved by the engine (an appliance swap, a bay edit) stands beside
// the generator's own fixtures — so a reader that trusts either field alone
// silently loses half a leg. Found 2026-09-24 twice on one kitchen: the
// peninsula elevation claimed the wall legs' cabinetry, and the pendant
// planner found no counter on a seated peninsula with three pendants up.
//
// Dependency-free, so kitchen-assembly can require it without a cycle.

/**
 * Every wall id `obj` names, in either field, in order, without repeats.
 *
 * @param {Object|null|undefined} obj
 * @returns {string[]}
 */
function objectWallIds(obj) {
  const ids = [];
  const add = (id) => {
    if (typeof id === 'string' && id && !ids.includes(id)) ids.push(id);
  };
  (obj?.parentWallIds || []).forEach(add);
  (obj?.cabinetWallRefs || []).forEach((ref) => add(ref?.id));
  return ids;
}

module.exports = { objectWallIds };
